<template>
  <div class="mt-4">
    <div class="row">
      <!-- Diabetes Clinic -->
      <div
        v-if="package_contains('diabetes')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/diabetes')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">💉</div>
            <h5 class="card-title mb-0">Diabetes Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Cardiology Clinic -->
      <div
        v-if="package_contains('cardiology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/cardiology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">❤️</div>
            <h5 class="card-title mb-0">Cardiology Clinic</h5>
          </div>
        </div>
      </div>

      <!-- ENT Clinic -->
      <div
        v-if="package_contains('ent')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/ent')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">👂</div>
            <h5 class="card-title mb-0">ENT Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Orthopedics Clinic -->
      <div
        v-if="package_contains('orthopedics')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/orthopedics')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🦴</div>
            <h5 class="card-title mb-0">Orthopedics Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Oncology Clinic -->
      <div
        v-if="package_contains('oncology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/oncology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🎗️</div>
            <h5 class="card-title mb-0">Oncology Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Dental Clinic -->
      <div
        v-if="package_contains('dental')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/dental_clinic/dental_queue')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🦷</div>
            <h5 class="card-title mb-0">Dental Clinic</h5>
          </div>
        </div>
      </div>

      <!-- MCH Clinic -->
      <div
        v-if="package_contains('mch')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/mch/mch_index')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">👶</div>
            <h5 class="card-title mb-0">MCH Clinic</h5>
          </div>
        </div>
      </div>

      <!-- NEW CLINICS ADDED BELOW -->

      <!-- Dermatology Clinic -->
      <div
        v-if="package_contains('dermatology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/dermatology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🌡️</div>
            <h5 class="card-title mb-0">Dermatology Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Neurology Clinic -->
      <div
        v-if="package_contains('neurology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/neurology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🧠</div>
            <h5 class="card-title mb-0">Neurology Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Ophthalmology Clinic -->
      <div
        v-if="package_contains('eye')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/eye_clinic/eye_queue')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">👁️</div>
            <h5 class="card-title mb-0">Eye Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Psychiatry Clinic -->
      <div
        v-if="package_contains('phychiatry')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/psychiatry')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🧠💭</div>
            <h5 class="card-title mb-0">Psychiatry Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Gastroenterology Clinic -->
      <div
        v-if="package_contains('gastroenterology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/gastroenterology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🍽️</div>
            <h5 class="card-title mb-0">Gastroenterology Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Nephrology Clinic -->
      <div
        v-if="package_contains('nephrology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/nephrology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🫁</div>
            <h5 class="card-title mb-0">Nephrology Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Pulmonology Clinic -->
      <div
        v-if="package_contains('pulmonology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/pulmonology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🌬️</div>
            <h5 class="card-title mb-0">Pulmonology Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Rheumatology Clinic -->
      <div
        v-if="package_contains('rheumatology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/rheumatology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🦵</div>
            <h5 class="card-title mb-0">Rheumatology Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Urology Clinic -->
      <div
        v-if="package_contains('urology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/urology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🚽</div>
            <h5 class="card-title mb-0">Urology Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Endocrinology Clinic -->
      <div
        v-if="package_contains('endocriminology')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/endocrinology')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">⚖️</div>
            <h5 class="card-title mb-0">Endocrinology Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Pediatrics Clinic -->
      <div
        v-if="package_contains('pediatrics')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/pediatrics')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">🚸</div>
            <h5 class="card-title mb-0">Pediatrics Clinic</h5>
          </div>
        </div>
      </div>

      <!-- Physiotherapy Clinic -->
      <div
        v-if="package_contains('physiotherapy')"
        class="col-lg-3 col-md-4 col-sm-6 mb-4"
      >
        <div
          class="card shadow h-100 clinic-card"
          @click="goToClinic('/special-clinics/physiotherapy')"
        >
          <div
            class="card-body d-flex flex-column justify-content-center align-items-center text-center"
          >
            <div class="clinic-icon mb-3">💪</div>
            <h5 class="card-title mb-0">Physiotherapy Clinic</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import package_contains from "./package_contains";
export default {
  name: "SpecialClinicsMenu",
  methods: {
    package_contains,
    goToClinic(route) {
      this.$router.push(route);
    },
  },
};
</script>

<style scoped>
.clinic-card {
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  border: 2px solid transparent;
}
.clinic-card:hover {
  transform: translateY(-5px);
  border-color: #007bff;
  background-color: rgba(247, 202, 202, 0.5);
}
.clinic-icon {
  font-size: 3rem;
}
/* Responsive adjustments */
@media (max-width: 768px) {
  .clinic-icon {
    font-size: 2.5rem;
  }
  h5.card-title {
    font-size: 1rem;
  }
}
</style>
